import { render } from "./MyAdviser.vue?vue&type=template&id=9d80abd6&scoped=true"
import script from "./MyAdviser.vue?vue&type=script&lang=js"
export * from "./MyAdviser.vue?vue&type=script&lang=js"

import "./MyAdviser.vue?vue&type=style&index=0&id=9d80abd6&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d80abd6"]])

export default __exports__